import ClientProcedureScreen from './ClientProcedureScreen.js';

export default ClientProcedureScreen;
